import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TorrentAccessGuard implements CanActivate {
  /** Prépare les dépendances utilisées pour décider si la navigation est autorisée. */
  constructor(private auth: AuthService, private router: Router) {}

  /** Autorise la navigation si la session possède les droits attendus. */
  canActivate(): Observable<boolean | UrlTree> {
    const roles = this.auth.getRoles();
    if (roles.includes('ADMIN') || roles.includes('TORRENT_ADD')) {
      return of(true);
    }
    return of(this.router.createUrlTree(['/access-denied']));
  }
}
